import React from "react";

interface IThank {
  formData: any
}

const ThankYouMessage: React.FC<IThank> = ({ formData }) => {
  const summaryData = {
    firstName: "SELECTED Vorname",
    lastName: "SELECTED Nachname",
    product: "SELECTED PRODUCT",
    productInstallation: "SELECTED ART",
    dimensions: {},
    ...formData
  };

  return (
    <div className="flex flex-col items-center bg-gray-100 rounded-3xl pb-8 ">


      <div className=" p-6 rounded-lg w-full">
        <p className="text-sm md:text-base mb-4">
          Wir haben Ihre Konfiguration erhalten und werden uns in Kürze mit Ihnen in Verbindung setzen. Hier ist eine Zusammenfassung Ihrer Angaben:
        </p>

        <ul className="list-disc list-inside text-sm md:text-base space-y-2 mx-2">
          <li>Vorname: {summaryData.personalDetails?.firstName}</li>
          <li>Nachname: {summaryData.personalDetails?.lastName}</li>
          <li>Produkt: {summaryData.product}</li>
          <li>Montageart: {summaryData.installationType}</li>
          <li>Breite: {summaryData?.dimensions?.width} m</li>
          <li>Tiefe: {summaryData?.dimensions?.depth} m</li>
          <li>Farbe: {summaryData?.color}</li>
          <li>LED-Option:{summaryData?.ledOption}</li>
          <li>Montage:{summaryData?.service}</li>
          <li>Standort: {summaryData?.selectedBranch?.name}</li>
        </ul>
        <p>Falls Sie weitere Fragen haben, stehen wir Ihnen jederzeit gerne zur Verfügung.
        </p>
      </div>

    </div>
  );
};

export default ThankYouMessage;
